export default [
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'bulletList',
    'mediaSingle',
    'codeBlock_with_no_marks',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'panel',
    'blockquote',
    'rule',
    'mediaGroup',
    'decisionList',
    'taskList',
    'table',
    'extension',
    'bodiedExtension',
    'expand_with_no_mark',
    'blockCard',
];
//# sourceMappingURL=block_content.js.map